import { Search, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Label } from '../../../components/ui/Label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../../../components/ui/Select';
import { cn } from '../../../lib/utils';

// ----------------------------------------------------------------------

type Props = {
  filterSearch: string;
  filterUnitId: string;
  isFiltered: boolean;
  optionsUnitId: string[];
  onFilterSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterUnitId: (value: string) => void;
  onResetFilter: VoidFunction;
  singleListing?: boolean;
  onFilterGuestType: (value: string) => void;
  filterGuestType: string;
  optionsGuestType: string[];
  className?: string;
};

export default function ReservationTableToolbar({
  filterSearch,
  filterUnitId,
  isFiltered,
  optionsUnitId,
  onFilterSearch,
  onFilterUnitId,
  onResetFilter,
  singleListing = false,
  onFilterGuestType,
  filterGuestType,
  optionsGuestType,
  className
}: Props) {
  return (
    <div className={cn('flex flex-col sm:flex-row items-center gap-4', className)}>
      {!singleListing && (
        <div className="w-full sm:max-w-[75px]">
          <Label className="sr-only">Property</Label>
          <Select value={filterUnitId} onValueChange={onFilterUnitId}>
            <SelectTrigger>
              <SelectValue placeholder="Property" />
            </SelectTrigger>
            <SelectContent>
              {optionsUnitId.map((option, i) => (
                <SelectItem key={`${option}-${i}`} value={option} className="capitalize">
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <div className="w-full sm:max-w-[75px]">
        <Label className="sr-only">Guest Type</Label>
        <Select value={filterGuestType} onValueChange={onFilterGuestType}>
          <SelectTrigger>
            <SelectValue placeholder="Guest Type" />
          </SelectTrigger>
          <SelectContent>
            {optionsGuestType.map((option, i) => (
              <SelectItem key={`${option}-${i}`} value={option} className="capitalize">
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="relative w-full">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={filterSearch}
          onChange={onFilterSearch}
          placeholder="Search..."
          className="pl-9 max-w-sm"
        />
      </div>

      {isFiltered && (
        <Button variant="destructive" className="shrink-0" onClick={onResetFilter}>
          <Trash2 className="mr-2 h-4 w-4" />
          Clear
        </Button>
      )}
    </div>
  );
}
